import { Capacitor } from '@capacitor/core';
import { settings } from '../environments/environment';

// У нативному застосунку веб-код вбудований і відкривається з capacitor://localhost (iOS) / https://localhost (Android),
// тож адресу сервера для WebSocket беремо з налаштувань, а не з window.location. У вебі — null (стара логіка).
export function nativeWsBase(): string | null {
  return Capacitor.isNativePlatform() ? settings.BASE_URL.replace(/^http/, 'ws') : null;
}
